import { Fragment, useEffect, useState } from "react";
import { Nav } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
//import "./UserForm.css";
import { useLocation, useParams } from "react-router-dom";
import BasicDetailsTab from "./BasicDetailsTab";
import PermissionsTab from "./PermissionTab";
import { MecordColors } from "Constants/Color";

const UserForm = (props: any) => {
  const [activeTab, setActiveTab] = useState("basic");
  const [disabled, setDisabled] = useState(true);
  const location = useLocation();
  const { id } = useParams();
  const { user_data } = location.state || {};
  const user_id_from_state = user_data?.user_id || "";

  // Get user_id from params (edit mode), state (navigation), or localStorage (after creation)
  const getUserId = () => {
    if (id) return id; // Edit mode from URL params
    if (user_id_from_state) return user_id_from_state; // From navigation state
    const storedUserId = localStorage.getItem("permission_user");
    if (storedUserId) {
      try {
        return JSON.parse(storedUserId);
      } catch {
        return storedUserId;
      }
    }
    return "";
  };

  const user_id = getUserId();
  const isEdit = Boolean(id || user_id_from_state);

  const renderContent = () => {
    switch (activeTab) {
      case "basic":
        return <BasicDetailsTab setActiveTab={setActiveTab} />;
      case "permissions":
        return <PermissionsTab id={user_id} />;
      default:
        return null;
    }
  };

  useEffect(() => {
    if (props?.page !== undefined) {
      setDisabled(false);
      setActiveTab("permissions");
    } else {
      // Enable permissions tab if user_id is available (after basic details submission)
      if (user_id) {
        setDisabled(false);
      }
    }
  }, [props, user_id]);

  // Listen for tab changes from BasicDetailsTab
  useEffect(() => {
    const storedUserId = localStorage.getItem("permission_user");
    if (storedUserId && activeTab === "permissions") {
      setDisabled(false);
    }
  }, [activeTab]);

  return (
    <Fragment>
      <div className="page-content px-4 " style={{ marginLeft: "15px" }}>
        <Nav
          variant="tabs"
          activeKey={activeTab}
          onSelect={(selectedKey) => selectedKey && setActiveTab(selectedKey)}
        >
          <Nav.Item>
            <Nav.Link
              eventKey="basic"
              style={{
                color:
                  activeTab === "basic"
                    ? MecordColors.ActiveText
                    : MecordColors.DefaultText,
                borderBottom:
                  activeTab === "basic"
                    ? `2px solid ${MecordColors.ActiveText}`
                    : "none",
              }}
              className="fw-semibold"
            >
              Basic Details
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              disabled={disabled}
              eventKey="permissions"
              style={{
                color:
                  activeTab === "permissions"
                    ? MecordColors.ActiveText
                    : MecordColors.DefaultText,
                borderBottom:
                  activeTab === "permissions"
                    ? `2px solid ${MecordColors.ActiveText}`
                    : "none",
              }}
              className="fw-semibold"
            >
              Permissions
            </Nav.Link>
          </Nav.Item>
        </Nav>

        <div className="mb-2">{renderContent()}</div>
      </div>
    </Fragment>
  );
};

export default UserForm;
